import {
  normalizeCountryCode,
  normalizeDisplayCurrency,
} from '../pricing/pricingStripeConfig';

function normalizeBillingCurrency(value) {
  return typeof value === 'string' && value.toLowerCase() === 'usd' ? 'usd' : 'eur';
}

function normalizePlan(value) {
  if (value === '3months' || value === '12months' || value === '11months') {
    return value;
  }
  return 'monthly';
}

function resolveProductLine({ productType, line }) {
  const normalizedLine = typeof line === 'string' ? line.toLowerCase() : '';

  if (productType === 'executive-mba' || normalizedLine === 'executive') {
    return 'executive';
  }
  if (productType === 'families' || normalizedLine === 'families') {
    return 'families';
  }
  if (normalizedLine === 'ielts') {
    return 'graduate_ielts';
  }
  return 'graduate_full';
}

function readStoredJson(storage, key) {
  if (!storage) return null;

  try {
    const raw = storage.getItem(key);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    console.error(`Error parsing ${key}:`, error);
    return null;
  }
}

export function buildPaymentIntentFromSearchParams(searchParams) {
  if (!searchParams) return null;

  const redirect = searchParams.get('redirect');
  if (redirect !== 'payment') return null;

  const productType = searchParams.get('product') || 'general';

  return {
    action: 'subscribe',
    plan: normalizePlan(searchParams.get('plan') || searchParams.get('type')),
    billingCurrency: normalizeBillingCurrency(
      searchParams.get('billing_currency') || searchParams.get('currency')
    ),
    displayCurrency: normalizeDisplayCurrency(
      searchParams.get('display_currency'),
      'EUR'
    ),
    country_code: normalizeCountryCode(searchParams.get('country_code')),
    productLine: resolveProductLine({
      productType,
      line: searchParams.get('line'),
    }),
    productType,
    pricing_segment:
      searchParams.get('pricing_segment') === 'legacy_graduate'
        ? 'legacy_graduate'
        : 'standard',
  };
}

export function getPaymentIntentFromStorageOrSearchParams(
  searchParams,
  storage = window.localStorage
) {
  return (
    readStoredJson(storage, 'payment_intent') ||
    buildPaymentIntentFromSearchParams(searchParams)
  );
}
